import { ESCPOS, normalizeForPrinter, getPrinterSettings } from "@/lib/qz-tray";
import { getPrinterNameForJob } from "@/lib/print-routing";
import { dispatchPrint } from "@/lib/print-dispatcher";
import { logger } from "@/lib/logger";

interface ExitReleaseData {
  commandNumber: string;
  employeeName?: string;
  terminalName?: string;
  restaurantName: string;
  restaurantId: string;
}

function formatExitRelease(data: ExitReleaseData, charsPerLine: number): string {
  const separator = "-".repeat(charsPerLine);
  const now = new Date();
  const dateStr = now.toLocaleDateString("pt-BR");
  const timeStr = now.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

  let content = "";

  // Init
  content += ESCPOS.INIT;

  // Title: SAIDA LIBERADA (centered, bold, double size)
  content += ESCPOS.ALIGN_CENTER;
  content += ESCPOS.BOLD_ON;
  content += ESCPOS.DOUBLE_SIZE_ON;
  content += normalizeForPrinter("SAIDA LIBERADA") + "\n";
  content += ESCPOS.DOUBLE_SIZE_OFF;
  content += ESCPOS.BOLD_OFF;

  content += "\n";
  content += normalizeForPrinter(separator) + "\n";
  content += "\n";

  // Date/time
  content += ESCPOS.ALIGN_LEFT;
  content += normalizeForPrinter(`Data: ${dateStr}  Hora: ${timeStr}`) + "\n";

  // Terminal
  if (data.terminalName) {
    content += normalizeForPrinter(`Terminal: ${data.terminalName}`) + "\n";
  }

  // Employee
  if (data.employeeName) {
    content += normalizeForPrinter(`Funcionario: ${data.employeeName}`) + "\n";
  }

  content += "\n";
  content += normalizeForPrinter(separator) + "\n";
  content += "\n";

  // Command number (bold, double size, centered)
  content += ESCPOS.ALIGN_CENTER;
  content += ESCPOS.BOLD_ON;
  content += ESCPOS.DOUBLE_SIZE_ON;
  content += normalizeForPrinter(`COMANDA ${data.commandNumber}`) + "\n";
  content += "\n";
  content += normalizeForPrinter("LIBERADO!!!") + "\n";
  content += ESCPOS.DOUBLE_SIZE_OFF;
  content += ESCPOS.BOLD_OFF;

  content += "\n";
  content += normalizeForPrinter(separator) + "\n";

  // Footer with restaurant name
  content += ESCPOS.ALIGN_CENTER;
  content += normalizeForPrinter(data.restaurantName) + "\n";
  content += "\n\n\n\n";

  // Cut
  content += ESCPOS.CUT_FULL;

  return content;
}

export async function printExitRelease(data: ExitReleaseData): Promise<void> {
  try {
    const printerName = await getPrinterNameForJob(data.restaurantId, "customer_receipt") || "default";
    const printerSettings = await getPrinterSettings(printerName, data.restaurantId);
    const charsPerLine = printerSettings?.chars_per_line || 48;

    const content = formatExitRelease(data, charsPerLine);

    await dispatchPrint(data.restaurantId, printerName, content, {
      logType: "saida_liberada",
      logIdentifier: data.commandNumber,
      locationName: "Saida Liberada",
      settings: printerSettings || undefined,
    });

    logger.log(`[ExitRelease] Printed for command ${data.commandNumber}`);
  } catch (error) {
    console.error("[ExitRelease] Error printing:", error);
  }
}
